import {
    BrowserRouter, Navigate, Routes, Route,
} from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import NotFound from '../pages/NotFound';
import IDProofing from '../pages/IDProofing';
import ScanImage from '../pages/ScanImage';
import Selfi from '../pages/Selfi';
import AdditionalInfo from '../pages/AdditionalInfo';
import Airplaneprofile from '../pages/Airplaneprofile';
import StartIssuance from '../pages/StartIssuance';
import StartIDProofing from '../pages/StartIDProofing';
import StartIDProofingChv from '../pages/StartIDProofingCHV';
import CheckStatus from '../pages/CheckStatus';
function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MainLayout />}>
                    <Route path="" element={<IDProofing />} /> 
                    <Route path="idproofing" element={<IDProofing />} />             
                    <Route path="scanimage" element={<ScanImage />} />            
                    <Route path="idproofing/scanimage" element={<ScanImage />} />                  
                    <Route path="idproofing/selfi" element={<Selfi />} />
                    <Route path="idproofing/selfi/:aid/:cardType?" element={<Selfi />} />                  
                    <Route path="idproofing/additionalinfo/:aid" element={<AdditionalInfo />} />  
                    <Route path="idproofing/startidproofing/:aid" element={<StartIDProofing />} />
                    <Route path="idproofing/startidproofingchv/:aid" element={<StartIDProofingChv />} />
                    <Route path="idproofing/startidproofingchv/checkstatus/:aid" element={<StartIDProofingChv />} />
                    <Route path="idproofing/startidproofingchv/chvscenario/:aid" element={<StartIDProofingChv />} />
                    <Route path="idproofing/startissuance/:aid" element={<StartIssuance />} />    
                    <Route path="idproofing/verification/:aid" element={<Airplaneprofile />} /> 
                    <Route path="idproofing/checkstatus/:aid" element={<CheckStatus />} />
                    <Route path="not-found" element={<NotFound />} />
                    <Route path="*" element={<Navigate to="/not-found" />} />

                </Route>            
            </Routes>
        </BrowserRouter>
    );
}

export default App;
